module.exports = __webpack_public_path__ + "img/dollarcoin.a2bec657.svg";